<script setup>
import { defineProps } from "vue";
const props = defineProps({
  title: { type: String, required: true },
  index: { type: [Number, String], required: true },
  cost: { type: String, required: false },
  text: { required: true },
  cols: { type: Boolean, default: true },
  rating: { type: Number, default: null },
});

const RATINGS = {
  1: { icon: "thumbs-up", label: "Good", class: "text-up dark:text-up-dark" },
  "-1": {
    icon: "thumbs-down",
    label: "Bad",
    class: "text-down dark:text-down-dark",
  },
  0: {
    icon: "minus",
    label: "Neither",
    class: "text-secondary dark:text-night-muted",
  },
};
</script>

<template>
  <section class="flex gap-4">
    <div class="flex flex-col items-center">
      <span
        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-sm font-semibold ring-1 ring-primary/10 dark:bg-night-card dark:ring-white/10"
        >{{ props.index }}</span
      >
      <span
        class="my-1 w-px flex-1 bg-primary/10 dark:bg-white/10"
        aria-hidden="true"
      />
    </div>
    <div class="min-w-0 flex-1 pb-6">
      <h3 class="font-semibold">{{ props.title }}</h3>
      <p v-if="props.cost" class="card-note mb-2">
        Cost {{ props.cost }}
        <span v-if="RATINGS[props.rating]" class="ml-4">
          Rating
          <span
            :class="RATINGS[props.rating].class"
            :title="RATINGS[props.rating].label"
          >
            <font-awesome-icon
              :icon="RATINGS[props.rating].icon"
              class="ml-1"
            />
            <span class="sr-only">{{ RATINGS[props.rating].label }}</span>
          </span>
        </span>
      </p>
      <div
        class="mt-1 whitespace-pre-wrap text-sm leading-relaxed"
        :class="props.cols ? 'columns-lg' : ''"
      >
        {{ props.text }}
      </div>
    </div>
  </section>
</template>
